import api, { adminApiPrefix } from './Api';
import {
  Menu,
  menuFromResponse,
  menuToUpsertRequest,
} from '../interfaces/Menu/Menu';

const menuAdminApiPrefix = `${adminApiPrefix}/menus`;

export const createMenu = async (menu: Menu): Promise<Menu> => {
  const response = await api.post(
    menuAdminApiPrefix,
    menuToUpsertRequest(menu),
  );

  return menuFromResponse(response.data?.data);
};

export const getMenus = async (): Promise<Menu[]> => {
  const response = await api.get(menuAdminApiPrefix);

  return (response.data?.data ?? []).map((menu: any) => menuFromResponse(menu));
};

export const getMenu = async (id: number): Promise<Menu> => {
  const response = await api.get(`${menuAdminApiPrefix}/${id}`);

  return menuFromResponse(response.data?.data);
};

export const updateMenu = async (menu: Menu): Promise<Menu> => {
  const response = await api.put(
    `${menuAdminApiPrefix}/${menu.id}`,
    menuToUpsertRequest(menu),
  );

  return menuFromResponse(response.data?.data);
};

export const deleteMenu = async (id: number): Promise<void> =>
  api.delete(`${menuAdminApiPrefix}/${id}`);
